import {
  Component,
  inject,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
  MatFormFieldModule,
} from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { FlowNode } from '../chatbot-flow-component';
import { MetodoRequisicaoEnum } from '../../shared/enum/metodo-requisicao-enum';
import { ContentTypeRequisicaoEnum } from '../../shared/enum/content-type-enum';
import { ButtonPadraoComponent } from '../../shared/components/button-padrao/button-padrao.component';
import { TipoParametroRequisicao } from '../../shared/enum/tipo-parametro-requisicao-enum';
import { FormFieldComponent } from '../../shared/components/form-field/form-field.component';
import { SelectOneComponent } from '../../shared/components/select-one/select-one.component';
import { ValidacaoAlteracaoCampoService } from '../../shared/service/utilitarios/validacao-alteracao-campo.service';
import { VariavelSelect } from '../../shared/model/variavel/variavel-select.model';
import { SelectMultipleComponent } from '../../shared/components/select-multiple/select-multiple.component';
import { TipoRetornoRequisicaoDeRetorno } from '../../shared/enum/tipo-retorno-requisicao-retorno-enum';
import { MatTooltip } from '@angular/material/tooltip';
import { EtapaRequisicaoBusca } from '../../shared/model/etapa/etapa-requisicao-busca.model';
import { ModalVisualizacaoJson } from '../../shared/modais/modal-visualizacao-json/modal-visualizacao-json';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-form-requisicao',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule,
    MatTooltip,
    FormsModule,
    MatInputModule,
    ButtonPadraoComponent,
    FormFieldComponent,
    SelectOneComponent,
    SelectMultipleComponent,
  ],
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline' },
    },
  ],
  templateUrl: './form-requisicao.component.html',
  styleUrl: './form-requisicao.component.css',
})
export class FormRequisicaoComponent implements OnInit, OnChanges {
  @Input() selectedNode: FlowNode | null = null;
  @Input() variaveisDoFluxoSelect: VariavelSelect[] = [];
  @Input() isRequisicaoRetorno = false;
  variaveisSelecionadas: VariavelSelect[] = [];
  tiposParametros: string[] = [];
  tiposRetornos: string[] = [];
  metodosComCorpo: string[] = ['POST', 'PUT', 'PATCH'];
  metodos: string[] = [];
  tiposConteudos: string[] = [];

  readonly alteracaoService = inject(ValidacaoAlteracaoCampoService);
  private readonly dialog = inject(MatDialog);

  ngOnInit(): void {
    this.metodos = Object.values(MetodoRequisicaoEnum);
    this.tiposConteudos = Object.values(ContentTypeRequisicaoEnum);
    this.tiposParametros = Object.values(TipoParametroRequisicao);
    this.tiposRetornos = Object.values(TipoRetornoRequisicaoDeRetorno);

    if (this.selectedNode && !this.selectedNode.requisicao) {
      this.selectedNode.requisicao = this.gerarRequisicaoDoNode();
    }

  }

  ngOnChanges(changes: SimpleChanges) {
    if (typeof changes['variaveisDoFluxoSelect'] != 'undefined') {
      if (
        typeof changes['variaveisDoFluxoSelect'].currentValue != 'undefined'
      ) {
        this.atualizarVariaveisSelecionadas();
      }
    }
  }

  adicionarCabecalho() {
    if (!this.selectedNode) return;

    if (!this.selectedNode.requisicao) {
      this.selectedNode.requisicao = this.gerarRequisicaoDoNode();
    }

    if (!this.selectedNode.requisicao.cabecalhos) {
      this.selectedNode.requisicao.cabecalhos = [];
    }

    this.selectedNode.requisicao.cabecalhos.push({ chave: '', valor: '' });
  }

  adicionarParametro() {
    if (!this.selectedNode) return;

    if (!this.selectedNode.requisicao) {
      this.selectedNode.requisicao = this.gerarRequisicaoDoNode();
    } else if (!this.selectedNode.requisicao.parametros) {
      this.selectedNode.requisicao.parametros = [];
    }

   this.selectedNode.requisicao!.parametros!.push({
      nome: '',
      valor: '',
      tipo: '',
    });
  }


  removerCabecalho(index: number) {
    this.selectedNode?.requisicao?.cabecalhos?.splice(index, 1);
  }

  removerParametro(index: number) {
    this.selectedNode?.requisicao?.parametros?.splice(index, 1);
  }

  selecionarVariaveis(event: any[]) {
    if (!this.selectedNode?.requisicao) return;

    if (event && event.length > 0) {
      this.selectedNode.requisicao.variaveisEnvio = event.map((e) => e.id);
    } else {
      this.selectedNode.requisicao.variaveisEnvio = [];
    }
    this.atualizarVariaveisSelecionadas();
  }

  atualizarVariaveisSelecionadas() {
    if (this.variaveisDoFluxoSelect.length > 0) {
      if (!this.selectedNode?.requisicao?.variaveisEnvio) {
        this.variaveisSelecionadas = [];
      } else {
        const ids = this.selectedNode.requisicao.variaveisEnvio;
        this.variaveisSelecionadas = this.variaveisDoFluxoSelect.filter((v) =>
          ids.includes(v.id)
        );
      }
    }
  }

  onUrlChange(value: string) {
    if (this.selectedNode?.requisicao) {
      this.selectedNode.requisicao.url = value;
      this.alteracaoService.camposAlterado();
    }
  }

  onCorpoChange(value: string) {
    if (this.selectedNode?.requisicao) {
      this.selectedNode.requisicao.corpo = value;
      this.alteracaoService.camposAlterado();
    }
  }

  montarTextoExemplo(tipoRetorno: string): string {
    switch (tipoRetorno) {
      case TipoRetornoRequisicaoDeRetorno.ARQUIVO:
        return JSON.stringify(
          {
            nomeArquivo: 'teste.pdf',
            base64: '001010010101010101010101010101',
            tipoConteudo: 'application/pdf',
          },
          null,
          2
        );
      case TipoRetornoRequisicaoDeRetorno.LISTA_OPCOES:
        return JSON.stringify(
          {
            tituloLista: 'Selecione:',
            opcoes:
            [
              { titulo: 'Opção 1', descricao: 'Descrição da opção 1' },
              { titulo: 'Opção 2', descricao: 'Descrição da opção 2' }
            ]
          },
          null,
          2
        );
      case TipoRetornoRequisicaoDeRetorno.MENSAGEM:
        return JSON.stringify(
          {
            mensagem: 'Olá, tudo bem?',
          },
          null,
          2
        );
      default:
        return 'O retorno esperado não foi definido para este tipo.';
    }
  }

  selecionarTipoRetorno(event: any) {
    const valorNormalizado = event?.value ?? event;

    if (!this.selectedNode) {
      return;
    }

    if (!this.selectedNode.requisicao) {
      this.selectedNode.requisicao = this.gerarRequisicaoDoNode();
    }

    this.selectedNode.requisicao.tipoRetorno = valorNormalizado;
  }

  abrirModalExemplo(tipoRetorno: string) {
    const texto = this.montarTextoExemplo(tipoRetorno);
    this.dialog.open(ModalVisualizacaoJson, {
      width: '600px',
      data: { texto }
    });
  }

  gerarRequisicaoDoNode():EtapaRequisicaoBusca{
    return {
        metodo: MetodoRequisicaoEnum.GET,
        url: '',
        corpo: '',
        contentType: '',
        cabecalhos: [],
        parametros: [],
        variaveisEnvio: [],
        tipoRetorno: '',
      };
  }

  selecionarMetodo(event: any){
    this.selectedNode!.requisicao!.metodo = event;
  }
}
